var map = {
	"./Discord.svg": 3598,
	"./Employees.svg": 5229,
	"./Facebook.svg": 7502,
	"./Google.svg": 8657,
	"./Instagram.svg": 7428,
	"./LinkedIn.svg": 6997,
	"./Slack.svg": 7050,
	"./Twitter.svg": 4092,
	"./Website.svg": 5357,
	"./Youtube.svg": 9177,
	"./add.svg": 6018,
	"./back.svg": 1215,
	"./chat.svg": 3058,
	"./cross.svg": 3342,
	"./date.svg": 1494,
	"./delete.svg": 4217,
	"./edit.svg": 8044,
	"./email.svg": 9168,
	"./fb.svg": 9258,
	"./location.svg": 2483,
	"./logout.svg": 5281,
	"./mdi_tick.svg": 4221,
	"./messages.svg": 4195,
	"./notifications.svg": 3213,
	"./phone.svg": 6289,
	"./play.svg": 5570,
	"./remove.svg": 2736,
	"./requests.svg": 2396,
	"./search.svg": 1238,
	"./tick.svg": 6355,
	"./user.svg": 5730,
	"./vimeo.svg": 8557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;